import { FilterSelectField } from "components/formFields/FilterSelectField";

import { i18n } from "services/i18nService";
import { AUDIT_EVENT_TYPE_OPTIONS } from "services/sosInventoryService/auditEvent/schema";
import { FORM_TYPES } from "services/sosInventoryService/formTemplate/schema";

import { ALL_FILTER_OPTION } from "appConstants";

const OPTIONS = {
  templatelibrary: [ALL_FILTER_OPTION, ...FORM_TYPES],
  formtemplate: [ALL_FILTER_OPTION, ...FORM_TYPES],
  auditevent: [ALL_FILTER_OPTION, ...AUDIT_EVENT_TYPE_OPTIONS],
};

export function EditTypeFilter(props) {
  const { filters, setFilters, objectType } = props;
  const { filterSettings } = filters;
  const { Type } = filterSettings;

  function handleChange(_, value) {
    setFilters((prevParams) => ({
      ...prevParams,
      filterSettings: { ...prevParams.filterSettings, Type: value?.id || "" },
      startingRecord: 1,
    }));
  }

  return (
    <FilterSelectField
      options={OPTIONS[objectType]}
      onValueChange={handleChange}
      value={Type ? { id: Type } : ALL_FILTER_OPTION}
      label={i18n("filter.Type")}
      disableClearable
    />
  );
}
